import { useEffect, useState } from "react";
import _ from "lodash";

import { Form, Checkbox, Col, Row } from "antd";
import { GKPresetColors } from "../../../MediaLibrary/EditModal/LeftSidebar/EditTab";

export const InputCheckboxGroup = (props) => {
  const { item, form, isCutoutModal, presetBgColor, templateData, setTemplateData, presetGkColor } = props;

  if (item.data) {
    item.data.sort((a, b) => a.shirtNumber - b.shirtNumber);
  }

  const otherGroupId =
    item.id === "lineup_players"
      ? "reserve_players"
      : item.id === "reserve_players"
        ? "lineup_players"
        : null;

  const [selectedValues, setSelectedValues] = useState(item.defaultValue || []);

  const MAX_SELECTION = 11;
  const SUB_MAX_SELECTION = 15;

  // Split data into two columns
  const midIndex = Math.ceil(item.data?.length / 2);
  const firstColumn = item.data?.slice(0, midIndex);
  const secondColumn = item.data?.slice(midIndex);
  const otherGroupValues = form?.getFieldValue(otherGroupId) || [];

  const handleChange = (checkedValues) => {
    let maxCount = item.id === 'lineup_players' ? MAX_SELECTION : SUB_MAX_SELECTION;
    if (checkedValues.length > maxCount) {
      checkedValues = checkedValues.slice(0, maxCount);
    }

    const prevValues = [...selectedValues];
    const added = checkedValues.find((val) => !prevValues.includes(val));
    const removed = prevValues.find((val) => !checkedValues.includes(val));
    const changedValue = added || removed;
    const allLineUpData = [...item.data];

    const updatedLineUp = allLineUpData.map(player => {
      if (player.id !== changedValue) return player;
      const updatedPlayer = { ...player };
      if (!added) return updatedPlayer;
      if (updatedPlayer.position === "Goalkeeper") {
        if (presetGkColor === GKPresetColors.black) {
          updatedPlayer.blackPos = (player.blackPos % player.blackLen) + 1;
        } else if (presetGkColor === GKPresetColors.gray) {
          updatedPlayer.grayPos = (player.grayPos % player.grayLen) + 1;
        } else if (presetGkColor === GKPresetColors.pink) {
          updatedPlayer.redPos = (player.redPos % player.redLen) + 1;
        }
        else {
          updatedPlayer.currentPos = (player.currentPos % player.posLen) + 1;
        }
      } else {
        if (presetBgColor === '#ad042b') {
          updatedPlayer.currentPos = (player.currentPos % player.posLen) + 1;
        } else if (presetBgColor === '#111111') {
          updatedPlayer.blackPos = (player.blackPos % player.blackLen) + 1;
        } else {
          updatedPlayer.grayPos = (player.grayPos % player.grayLen) + 1;
        }
      }
      return updatedPlayer;
    }).filter(player => player.type !== 'manualPlayer');
    setSelectedValues(checkedValues);

    const updatedTemplateData = _.cloneDeep(templateData);
    const index = updatedTemplateData.data.fields.findIndex(f => f.id === 'lineup_players');
    if (index !== -1) {
      _.set(updatedTemplateData, `data.fields[${index}].data`, updatedLineUp);
    }
    setTemplateData(updatedTemplateData)

    form?.setFieldsValue({
      [item.id]: checkedValues,
    });
  };

  const isDisabled = (playerId) => {
    return otherGroupId && otherGroupValues.includes(playerId);
  };

  useEffect(() => {
    if (["lineup_players", "reserve_players"].includes(item.id)) {
      const currentValues = form.getFieldValue(item.id) || [];
      setSelectedValues(currentValues);
    }
  }, [item.id]);

  return (
    <>
      <Form.Item
        label={!isCutoutModal && item.label}
        name={item?.id}
        rules={[{ required: false, message: "Please input your username!" }]}
        tooltip={props.tooltip}
        style={props?.style}
        initialValue={item.defaultValue || ""}
      >
        <Checkbox.Group
          style={{
            width: "100%",
          }}
          // value={selectedList}
          // onChange={onChange}
          value={selectedValues}
          onChange={handleChange}
        >
          {["lineup_players", "reserve_players"].includes(item.id) ? (
            <Row style={{ display: 'flex'}}> 
              {isCutoutModal ?
                (

                  <>
                    <Col span={12}>
                      {
                        item.data?.slice(0, Math.ceil(item.data.length / 2)).map((element, index) => (
                          <Checkbox
                            key={index}
                            value={element.id}
                            disabled={isDisabled(element.id)}
                          >
                            <div style={{ display: "flex", fontSize: 18 }}>
                              <span
                                style={{
                                  width: 25,
                                  textAlign: "center",
                                  marginRight: 3,
                                }}
                              >
                                {element.shirtNumber}
                              </span>
                              <span
                                style={{
                                  width: 150,
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {element.shortLastName}
                              </span>
                            </div>
                          </Checkbox>
                        ))}
                    </Col>

                    <Col span={12}>
                      {
                        item.data?.slice(Math.ceil(item.data.length / 2)).map((element, index) => (
                          <Checkbox
                            key={index}
                            value={element.id}
                            disabled={isDisabled(element.id)}
                          >
                            <div style={{ display: "flex", fontSize: 18 }}>
                              <span
                                style={{
                                  width: 25,
                                  textAlign: "center",
                                  marginRight: 3,
                                }}
                              >
                                {element.shirtNumber}
                              </span>
                              <span
                                style={{
                                  width: 150,
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {element.shortLastName}
                              </span>
                            </div>
                          </Checkbox>
                        ))}
                    </Col>
                  </>
                ) : (
                  <>
                    <Col span={12} style={{ paddingBottom: 10 }}>
                      {firstColumn.map((element, index) => (
                        <Checkbox
                          key={index}
                          value={element.id}
                          disabled={isDisabled(element.id)}
                        >
                          <div style={{ display: "flex" }}>
                            <span
                              style={{
                                width: 16,
                                textAlign: "end",
                                marginRight: 3,
                              }}
                            >
                              {element.shirtNumber}
                            </span>
                            <span
                              style={{
                                width: 160,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {element.label}
                            </span>
                          </div>
                        </Checkbox>
                      ))}
                    </Col>

                    <Col span={12}>
                      {secondColumn.map((element, index) => (
                        <Checkbox
                          key={index}
                          value={element.id}
                          disabled={isDisabled(element.id)}
                        >
                          <div style={{ display: "flex" }}>
                            <span
                              style={{
                                width: 16,
                                textAlign: "end",
                                marginRight: 3,
                              }}
                            >
                              {element.shirtNumber}
                            </span>
                            <span
                              style={{
                                width: 160,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {element.label}
                            </span>
                          </div>
                        </Checkbox>
                      ))}
                    </Col>
                  </>
                )}
            </Row>
          ) : (
            <Row>
              {item.data?.map((element, index) => {
                return (
                  <Col span={12} key={index}>
                    <Checkbox value={element.id} onChange={handleChange}>
                      <div style={{ display: "flex" }}>
                        <span
                          style={{
                            display: "inline-block",
                            width: 16,
                            textAlign: "end",
                            marginRight: 3,
                          }}
                        >
                          {element.shirtNumber}
                        </span>
                        <span
                          style={{
                            display: "inline-block",
                            width: 160,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {element.label}
                        </span>
                      </div>
                    </Checkbox>
                  </Col>
                );
              })}
            </Row>
          )}
        </Checkbox.Group>
      </Form.Item>
    </>
  );
};
